import { render, staticRenderFns } from "./remittanceInfoBox.vue?vue&type=template&id=57fcc861"
import script from "./remittanceInfoBox.vue?vue&type=script&lang=js"
export * from "./remittanceInfoBox.vue?vue&type=script&lang=js"
import style0 from "./remittanceInfoBox.vue?vue&type=style&index=0&id=57fcc861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports